import React from "react";

export default function ArrowDown() {
  return (
    <svg
      width="8px"
      height="9px"
      viewBox="0 0 8 9"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      >
        <g
          id="Text-/-Number-/-Change-Down"
          transform="translate(1.000000, -5.000000)"
          stroke="#EA0C01"
        >
          <g id="Icons-/-Arrows-/-Point-Down" transform="translate(0.000000, 5.000000)">
            <path
              d="M3.07894737,8.76315789 L0.236842105,5.92105263 M3.07894737,8.76315789 L5.92105263,5.92105263 M3.07894737,0.225 L3.07894737,8.775"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
